import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c28c833"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  "data-bs-theme": "light"
}
const _hoisted_2 = { class: "user-info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "My Tasks", -1))
const _hoisted_4 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_5 = {
  key: 1,
  class: "tasktablecontainer"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }

import TaskList from "@/components/TaskList.vue";
import { useEmployeeStore } from "@/stores/UserEmployee";
import { useTaskStore } from "@/stores/Tasks";
import { storeToRefs } from "pinia";
import { onMounted, computed, watch } from "vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'OpsHome',
  setup(__props) {

const userStore = useEmployeeStore();
const taskStore = useTaskStore();

const { getMyTasks, current_task, isLoadingTaks } = storeToRefs(taskStore);
const { currentUser } = storeToRefs(userStore);

const greeting = computed(() => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good Morning';
  if (hour < 18) return 'Good Afternoon';
  return 'Good Evening';
});

onMounted(() => {
  // console.log("Current Task ID:", current_task.value);
  taskStore.getAllTasks();
});

watch(getMyTasks, (newTasks) => {
  if (newTasks) {
    // You can perform additional actions here if needed,
    // such as logging or handling the data differently.
  }
}, { immediate: true });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(greeting.value) + ", " + _toDisplayString(_unref(currentUser)?.user.full_name), 1),
      _hoisted_3
    ]),
    (_unref(isLoadingTaks))
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(currentUser)?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createVNode(TaskList, {
                  tasks: _unref(getMyTasks),
                  visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'labor_cost', 'actions']
                }, null, 8, ["tasks"])
              ]))
            : _createCommentVNode("", true),
          (_unref(currentUser)?.user.is_staff && !_unref(currentUser)?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(TaskList, {
                  tasks: _unref(getMyTasks),
                  visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'actions']
                }, null, 8, ["tasks"])
              ]))
            : _createCommentVNode("", true),
          (!_unref(currentUser)?.user.is_staff && !_unref(currentUser)?.user.is_superuser)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(TaskList, {
                  tasks: _unref(getMyTasks),
                  visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'actions']
                }, null, 8, ["tasks"])
              ]))
            : _createCommentVNode("", true)
        ]))
  ]))
}
}

})